import React from 'react';

import env from 'lib/env';
import { imageCdnAsset } from 'lib/common/url-helpers';

import FAQItem from 'components/business/faq/item';

const { ENTERPRISE_HOST } = env();

const BusinessFAQ = () => (
  <div id="content">
    <div className="container-fluid bg-dark-steel-grey bottom-border-red" id="faq-image-block">
      <div className="container">
        <div className="row content-block double-padding">
          <div className="col-xs-10 col-xs-push-1 col-sm-12 col-sm-push-0 text-center">
            <img src={imageCdnAsset('assets/images/icons/icon-question-pin@2x.png')} alt="" id="icon-question-pin" />
            <h2>Get <strong>Answers</strong> to <strong>FAQ<span className="lowercase">s</span></strong> About ParkWhiz For Business</h2>
          </div>
        </div>
      </div>
    </div>

    <div className="container-fluid bg-off-white">
      <div className="container content-block">
        <div className="row">
          <div className="col-xs-10 col-xs-push-1">
            <div className="panel-group" id="accordion" role="tablist" aria-multiselectable="true">

              <h3 className="dark">Getting Started</h3>
              <FAQItem
                title="What is ParkWhiz for Business?"
                content="PW4B is a suite of solutions built to meet your company's parking needs. After setting up your business account, you'll have access to a variety of features, which include a single payment method for employees and the ability to send parking directly to visitors at better than drive-up rates."
              />
              <FAQItem
                title="How do I sign up?"
                content="Signing up is simple and free. Just share a few pieces of information about your business and then create an account log-in. Your account log-in will be the same for ParkWhiz and ParkWhiz for Business. Ready to get started? Click the button at the top of the page to Enroll Now"
              />
              <FAQItem
                title="What does it cost?"
                content="There's no cost to sign up. Our business solutions are provided free of charge!"
              />

              <h3 className="dark gap-top">Account &amp; Setup</h3>
              <FAQItem
                title="How do I access my business dashboard?"
                content={`Log into <a href="${ENTERPRISE_HOST}" className="business-portal-link" target="_blank">business.parkwhiz.com</a>. You can also access your dashboard through our main website by selecting "Business Admin" from your ParkWhiz account page. Unfortunately, you can’t access your business dashboard from our mobile apps.`}
              />
              <FAQItem
                title="How do I set up my business payment?"
                content={`You can manage payment settings for your business account through our <a href="${ENTERPRISE_HOST}" className="business-portal-link" target="_blank">portal</a>. At this time, we accept all major credit cards for payment. Bulk invoicing coming soon.`}
              />
              <FAQItem
                title="How do I add or remove employees?"
                content={`You can add or remove employees in the "Employees" tab of the business <a href="${ENTERPRISE_HOST}" className="business-portal-link" target="_blank">portal</a>. You'll need employee's name, email address, and phone number (optional). Details are in the portal for how to bulk upload with a .csv file or <a href="mailto:business@parkwhiz.com">contact us</a> directly and we'll do it for you.`}
              />
              <FAQItem
                title="How do I add other administrators to my business account?"
                content={`In the "Employees" tab of the business <a href="${ENTERPRISE_HOST}" className="business-portal-link" target="_blank">portal</a>, select the user you'd like to add. With that user's profile open, select "Edit User" and check the box to "Allow this user to administrate this account."`}
              />
              <FAQItem
                title="How can employees use our business payment online or in the app?"
                content="If your company has signed up for ParkWhiz for Business and added you as an employee, then you're all set. When checking out on the website or the app, simply choose your Enterprise Account as your Payment type."
              />
              <FAQItem
                title="How can employees provide expense memos for their parking purchase?"
                content={'When you select "Enterprise Account" as your payment type, an "Expense Memo" will be made available for you to enter any notes about this parking reservation.'}
              />

              <h3 className="dark gap-top">Dashboard and Sending Parking</h3>
              <FAQItem
                title="Where can I view my company's parking reservations?"
                content={`You can view your company's reservations in our business <a href="${ENTERPRISE_HOST}" className="business-portal-link" target="_blank">portal</a>. This includes parking reservations for your employees as well as your visitors. You can also view both past and upcoming reservations.`}
              />
              <FAQItem
                title="How do I send parking to someone?"
                content={`In the business <a href="${ENTERPRISE_HOST}" className="business-portal-link" target="_blank">portal</a>, use the search tool to find a parking location, date and time. Then provide a few details about the recipient and specify the discount you'd like to offer. They'll receive an email once the reservation is sent, where they can confirm the details and book their pass.`}
              />
              <FAQItem
                title="What will my visitors receive when I send them parking?"
                content={'Visitors will receive an email with a custom link to their reservation. This reservation automatically applies the discount (full or partial) that you wish to provide for their parking. You can also customize a message to include in this email.'}
              />
              <FAQItem
                title="How can I customize what discount I want to provide visitors on their parking?"
                content={`Our "Send Parking" tool allows you to decide what dollar value you'd like to cover. You can add as little as $1 or cover the full amount. To ensure that you cover the entire cost, you can set the discount value as high as you'd like. You will only be charged for the actual cost of the booking.`}
              />
              <FAQItem
                title="Looking for more information about ParkWhiz in general?"
                content={`Visit our <a href="http://help.parkwhiz.com" target="_blank">ParkWhiz Help Center</a>.`}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default BusinessFAQ;
